import { Link } from '@tanstack/react-router';

interface ProjectsListViewToggleProps {
  activeView: 'grid' | 'timeline';
}

/**
 * Segmented control for switching between the Projects Grid (default,
 * tabular view of every project) and the Timeline view (cross-project
 * planner, currently a blank-slate placeholder).
 */
export function ProjectsListViewToggle({ activeView }: ProjectsListViewToggleProps) {
  return (
    <nav
      aria-label="Projects view"
      className="bg-muted inline-flex items-center gap-0.5 rounded-md p-0.5"
    >
      <Link
        to="/projects"
        className={`rounded-sm px-3 py-1 text-sm transition-colors ${
          activeView === 'grid'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        aria-current={activeView === 'grid' ? 'page' : undefined}
      >
        Grid
      </Link>
      <Link
        to="/projects/timeline"
        className={`rounded-sm px-3 py-1 text-sm transition-colors ${
          activeView === 'timeline'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        aria-current={activeView === 'timeline' ? 'page' : undefined}
      >
        Timeline
      </Link>
    </nav>
  );
}
